module.exports = __webpack_public_path__ + "img/mena-woman.24208a70.svg";